module.exports = __webpack_public_path__ + "static/media/fruit_jesus_4.acdc316b.jpeg";